var map = {
	"./asbar/asbar-en.json": [
		7455,
		455
	],
	"./mulkia/mulkia-en.json": [
		5347,
		347
	],
	"./valueCapital/valueCapital-en.json": [
		899,
		899
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5200;
module.exports = webpackAsyncContext;